import React from 'react'
import { graphql, Link } from 'gatsby'
import clsx from 'clsx'
import './button.scss'

export const Button = ({
  label = '',
  variant = 'primary',
  otherClasses,
  form,
  type,
  externalLink,
  slug,
  onClick,
}) => {
  const buttonClasses = clsx(
    otherClasses,
    variant === 'primary' &&
      `px-6 lg:px-8 py-2 lg:py-3 rounded-full lg:text-base font-semibold leading-6 text-white font-work-sans bg-primary_dark_blue_500 transition-all duration-[0.20s] hover:bg-primary_blue_300 hover:text-primary_heading_color focus:outline-[2px] focus:outline-primary_dark_blue_700 focus:outline focus:bg-primary_dark_blue_500 focus:text-white active:bg-primary_blue_300 active:text-primary_heading_color active:outline-[0px]`,
    variant === 'secondary' &&
      `px-6 lg:px-8 py-2 lg:py-3 rounded-full lg:text-base font-semibold leading-6 text-gray-900 font-work-sans bg-primary_blue_50 transition-all duration-[0.20s] hover:bg-primary_blue_300 hover:text-gray-900 focus:outline-[2px] focus:outline-primary_dark_blue_500 focus:outline focus:bg-primary_blue_50 focus:text-gray-900 active:bg-primary_blue_300 active:text-gray-900 active:outline-[0px]`,
    variant === 'tertiary' &&
      `px-6 lg:px-8 py-2 lg:py-3 rounded-full lg:text-base font-semibold leading-6 text-gray-900 font-work-sans outline-[1px] outline outline-gray-900 transition-all duration-[0.20s] hover:bg-primary_blue_300 hover:text-gray-900 focus:outline-[2px] focus:outline-primary_dark_blue_500 focus:text-gray-900 active:bg-primary_blue_300 active:text-gray-900 active:outline-[1px] active:outline-gray-900`,
    variant === 'dark-text-link' &&
      `px-2 py-1 rounded-[8px] text-[12px] lg:text-sm font-semibold leading-[18px] text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] uppercase hover:text-primary_dark_blue_500 focus:text-white focus:outline-[2px] focus:outline focus:outline-primary_dark_blue_500 active:outline-[0px] active:text-primary_dark_blue_500`,
    variant === 'light-text-link' &&
      `px-2 py-1 rounded-[8px] text-[12px] lg:text-sm font-semibold leading-[18px] text-primary_heading_color font-work-sans tracking-[0.36px] lg:tracking-[0.42px] uppercase hover:text-primary_dark_blue_500 focus:text-primary_heading_color focus:outline-[2px] focus:outline focus:outline-primary_dark_blue_500 active:outline-[0px] active:text-primary_dark_blue_500`
  )

  if (slug) {
    const { current } = slug
    return (
      <>
        {externalLink ? (
          <a
            className={buttonClasses}
            href={current}
            target="_blank"
            rel="noopener noreferrer"
          >
            {label}
          </a>
        ) : (
          <Link
            className={buttonClasses}
            to={`/${current}`}
            target="_self"
            rel=""
          >
            {label}
          </Link>
        )}
      </>
    )
  }

  return (
    <button
      type={type}
      onClick={(e) => {
        onClick && onClick(form, e)
      }}
      className={buttonClasses}
      data-testid="button"
    >
      {label}
    </button>
  )
}

export default Button

export const query = graphql`
  fragment Button on SanityButton {
    label
    variant
    action
    externalLink
    form
    slug {
      current
    }
  }
`
